<template>
  <v-dialog v-model="dialog"
            light
            style="z-index: 1050;"
            hide-overlay
            max-width="600">
    <v-card class="offer-request-form">
      <v-form ref="offerRequestForm">
        <v-card-title>
          <h1 :style="{fontSize: $vuetify.breakpoint.xsOnly ? '18px' : ''}">Laskentakaavat</h1>
          <v-spacer></v-spacer>
          <v-icon @click="dialog = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text style="width: auto;">
          <p>Kysy tarkempia tietoja laskennassa käytetyistä tiedoista myynnistämme: <a href="mailto:myynti.energiapalvelut@porienergia.fi">myynti.energiapalvelut@porienergia.fi</a></p>

          <h2>Maalämmitys (MLP):</h2>
          <p>Kaavoissa on käytetty {{ maalampoKapasiteettiMitoitus }}%:n kapasiteettimitoitusta. Hyötysuhteena on {{ maalampoCop }} (COP). Investointi pitää sisällään kompressoriuusinnan, jonka toimintaikä on 15 – 20 vuotta.</p>

          <h2>Öljylämmitys:</h2>
          <p>Käytetty hyötysuhde {{ oljyHyotysuhde }}. Kevyen polttoöljyn hinnaksi on määritelty {{ oljyLitraHinta }} €/l. Tehoarvona 1 l = {{ oljyLitranEnergia }} kWh.</p>

          <h2>Ilmavesilämpöpumppu (IVLP):</h2>
          <p>Kaavoissa on käytetty {{ ilmavesiMitoitusSuhde }}%:n kapasiteettimitoitusta. Hyötysuhteena on {{ ilmavesiCop }} (COP).</p>

          <h2>Yhteisesti käytettyjä tekijöitä:</h2>
          <p>Pääomakustannuksen korko 2%. Laina-aika {{ lainaAika }} vuotta. Sähköenergian kustannuksena {{ sahkonHinta }} €/MWh. Laskelmissa käytetty käyttöikä on {{ kayttoIka }} vuotta.</p>

          <p><strong>Pääomakustannukset</strong> tarkoittavat mahdollisen investoinnin tarvitseman lainarahan vuosittaisia kustannuksia.</p>

          <p><strong>Kiinteät kustannukset</strong> tarkoittavat laitteiston ylläpitoon tai ylläpitoon liittyviin maksuihin perustuvia kustannuksia vuosittain.</p>

          <p><strong>Muuttuvat kustannukset</strong> tarkoittavat lämmitysenergian käyttämiä polttoainekustannuksia.</p>

          <p><strong>Energian kokonaiskustannukset</strong> tarkoittavat näiden edellä mainittujen kustannusten yhteenlaskettua summaa jaettuna tarvittavalla lämmitysenergian määrällä. Tämän avulla on helppo verrata eri lämmitysmuotoja keskenään. </p>

          <p>Muiden lämmitysmuotojen (maalämpö, öljy, ilmavesi, sähkö) investointikustannuksina on käytetty arvioita.</p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text x-large @click="dialog = false">Sulje</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
  import parametrit from '../formulas/yhteiset_parametrit';
  import { parametrit as oljyParametrit } from '../formulas/oljy';
  import { parametrit as maalampoParametrit } from '../formulas/maalampo';
  import { parametrit as ilmavesiParametrit } from '../formulas/ilmavesi';

  export default {
    name: "CalculationsExplainedDialog",
    data: () => {
      return {
        dialog: false,
      }
    },
    computed: {
      // maalampo
      maalampoKapasiteettiMitoitus() {
        return maalampoParametrit.mitoitus_suhde * 100;
      },
      maalampoCop() {
        return maalampoParametrit.cop;
      },
      // öljy
      oljyHyotysuhde() {
        return oljyParametrit.hyotysuhde;
      },
      oljyLitraHinta() {
        return oljyParametrit.hinta_per_litra;
      },
      oljyLitranEnergia() {
        return oljyParametrit.litran_energia * 1000;
      },
      // ilmavesi
      ilmavesiMitoitusSuhde() {
        return ilmavesiParametrit.mitoitus_suhde * 100;
      },
      ilmavesiCop() {
        return ilmavesiParametrit.cop;
      },
      sahkonHinta() {
        return parametrit.sahkon_hinta;
      },
      lainaAika() {
        return parametrit.laina_aika;
      },
      kayttoIka() {
        return parametrit.kayttoika;
      }
    },
    methods: {
      open() {
        this.dialog = true;
      },
    }
  }
</script>

<style scoped>

</style>
